import { render, staticRenderFns } from "./googlePrivacy-2.0-EN.vue?vue&type=template&id=38d0f628&scoped=true&"
import script from "./googlePrivacy-2.0-EN.vue?vue&type=script&lang=js&"
export * from "./googlePrivacy-2.0-EN.vue?vue&type=script&lang=js&"
import style0 from "./googlePrivacy-2.0-EN.vue?vue&type=style&index=0&id=38d0f628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d0f628",
  null
  
)

export default component.exports